function Mapper () {
  function card (data, addMessage) {
    return {
      id: data.id,
      brand: data.brand,
      expMonth: data.exp_month,
      expYear: data.exp_year,
      last4Digits: data.last_4_digits,
      message: addMessage ? 'Card Saved Successfully' : null
    }
  }

  function ach (data) {
    return {
      accountHolderName: data.account_holder_name,
      accountHolderType: data.account_holder_type,
      bankName: data.bank_name,
      country: data.country,
      currency: data.currency,
      customer: data.customer,
      fingerprint: data.fingerprint,
      id: data.id,
      last4: data.last4,
      metadata: data.metadata,
      object: data.object,
      routingNumber: data.routing_number,
      status: data.status
    }
  }

  function summary (data) {
    const ap = data.additional_purchases
    const ba = data.order_details.billing_address
    const sa = data.order_details.shipping_address
    const pa = data.order_details.payment
    const pi = data.order_details.payment.payment_info
    const to = data.totals

    return {
      checkoutLink: data.checkout_link,
      additionalPurchases: {
        hasPurchasedInspection: ap.has_purchased_inspection,
        hasPurchasedInsurance: ap.has_purchased_insurance,
        hasPurchasedTesting: ap.has_purchased_testing,
        hasSignedUpForDrs: ap.has_signed_up_for_drs
      },
      cart: data.cart.map(item => {
        return {
          incoTerms: item.inco_terms,
          port: item.port,
          price: item.price,
          id: item.product_id_token,
          name: item.product_name,
          quantity: item.quantity,
          subTotal: item.sub_total
        }
      }),
      orderDetails: {
        isSamebillingAddress: data.order_details.is_same_billing_address,
        billingAddress: ba,
        shippingAddress: sa,
        payment: {
          paymentMethod: pa.payment_method,
          paymentInfo: {
            brand: pi.brand,
            last$Digits: pi.last_4_digits
          }
        }
      },
      totals: {
        drsSignUpCharges: to.drs_sign_up_charges,
        exportInsurance: to.export_insurance,
        grandTotal: to.grand_total,
        inspectionCharges: to.inspection_charges,
        orderTotal: to.order_total,
        platformCharges: to.platform_charges,
        taxTotal: to.tax_total
      }
    }
  }

  return {
    card,
    ach,
    summary
  }
}

export default Mapper()
